import type {
  DocNodeBasicSummaryDto,
  DocNodeFileTreeItem,
} from "features/DMS/entities";
import { getAllParentPaths } from "features/DMS/utils/getAllParentPaths";

export function buildDocNodeFileTreeFromSummaryDto(
  data: DocNodeBasicSummaryDto[]
): DocNodeFileTreeItem[] {
  const rootItems: DocNodeFileTreeItem[] = [];
  for (const docNode of data) {
    if (!docNode.path || !docNode.name || !docNode.type) {
      continue;
    }
    const path = docNode.path;
    const parents = getAllParentPaths(path);
    const newTreeItem: DocNodeFileTreeItem = {
      id: path,
      path,
      label: docNode.name,
      type: docNode.type as "Library" | "Folder",
      nodeId: docNode.id!,
      children: [],
    };
    let currentList = rootItems;
    // traverse the tree, creating temp nodes as needed
    while (parents.length > 0) {
      const currentPath = parents.shift();
      const newList = currentList.find(
        (item) => item.path === currentPath
      )?.children;
      if (newList) {
        currentList = newList;
        continue;
      }
      const tempNode: DocNodeFileTreeItem = {
        id: currentPath!,
        path: currentPath!,
        label: "temp",
        type: "Temp",
        nodeId: "temp",
        children: [],
      };
      currentList.push(tempNode);
      currentList = tempNode.children!;
    }
    const tempItem = currentList.find((item) => item.path === path);
    if (tempItem) {
      tempItem.label = newTreeItem.label;
      tempItem.type = newTreeItem.type;
      tempItem.nodeId = newTreeItem.nodeId;
      continue;
    }
    currentList.push(newTreeItem);
  }
  function pruneTempNodes(items: DocNodeFileTreeItem[]) {
    for (let i = items.length - 1; i >= 0; i--) {
      const item = items[i];
      if (!item) {
        continue;
      }
      if (item.type === "Temp") {
        items.splice(i, 1);
        continue;
      }
      if (item.children && item.children.length > 0) {
        pruneTempNodes(item.children);
      }
    }
  }
  pruneTempNodes(rootItems);
  return rootItems;
}
